import React, { useState } from "react";
import css from "./MobileBottomTab.module.css";

import {
  bookingIconGray,
  HomeIconGray,
  ProfileIconGray,
  NotificationIconGray,
  messageIconGray,
} from "../../constant/imagePath";
import Fonts from "../assets/Fonts";
import { ReactSVG } from "react-svg";
import Colors from "../assets/Colors";
import PropTypes from "prop-types";
import { useHistory } from "react-router-dom";

const MobileBottomTab = ({ menus, state, setter }) => {
  const history = useHistory()
  return (
    <div
      className={css.tabMainContainer}
      style={{ borderTop: `1px solid ${Colors.neutralShadesOfGainsboro}` }}
    >
      <style jsx>{`
        .${css.imageSelected} {
          stroke: ${Colors.mainShadeOfRed};
        }
        .${css.imageSelected} path,
        .${css.imageSelected} rect {
          stroke: ${Colors.mainShadeOfRed};
          fill: ${state === "Profile" && Colors.mainShadeOfRed};
        }
        .${css.imageSelected} circle {
          fill: ${Colors.mainShadeOfRed};
        }
      `}</style>
      <ul>
        {menus?.map((item, index) => {
          return (
            <li onClick={() => (setter ? setter(item?.title) : history.push(item?.route))}>
              <div>
                <ReactSVG
                  src={item.icon}
                  beforeInjection={(svg) => {
                    svg.classList.add(
                      state === item?.title && css.imageSelected,
                      state === item?.activeText && css.imageSelected
                    );
                  }}
                />
              </div>
              <p
                style={{
                  ...Fonts.input2,
                  fontSize: "10px",
                  ...(state === item?.activeText && { fontFamily: 'inter-600', color: Colors.neutralShadesOfNero })
                }}
              >
                {item.title}
              </p>
            </li>
          );
        })}
      </ul>
    </div >
  );
};

MobileBottomTab.propTypes = {
  menus: PropTypes.array,
  state: PropTypes.string,
  setter: PropTypes.func,
};
MobileBottomTab.defaultProps = {
  menus: [
    {
      title: "To do",
      icon: HomeIconGray,
      activeText: 'todo',
      route: '/todo'
    },
    {
      title: "Schedule",
      icon: bookingIconGray,
      activeText: 'schedule',
      route: '/schedule'
    },
    {
      title: "Notifications",
      icon: NotificationIconGray,
      activeText: 'notifications',
      route: '/notifications'
    },
    {
      title: "Chats",
      icon: messageIconGray,
      activeText: 'chat',
      route: '/chat'

    },
    {
      title: "Profile",
      icon: ProfileIconGray,
      activeText: 'profile',
      route: '/profile'

    },
  ],
};

export default MobileBottomTab;
